import { inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { BentoStore } from 'src/common/bento/bento-store';
import { CurrentHotelStore } from 'stores/current-hotel-store';

import { BentoFeature } from 'src/common/bento/types';
import { ScrollTarget, StickyOfferModel } from 'src/common/models';

import { UitkCard, UitkCardContent } from 'uitk-react-cards';

import { BackLink } from './property-details/components/back-link';
import { InformationLarge } from 'components/infosite/property-details/information.tsx';
import { NavigationRefs } from './navigation/navigation-refs';
import { PropertyBadges } from './property-details/property-badges';

export interface PropertySummaryProps {
  backToHsrUrl: string;
  goBack: () => void;
  hotelName?: string;
  englishHotelName?: string;
  stars?: string;
  starRatingIcon?: string;
  stickyOffer?: StickyOfferModel;
  roomsAndRatesTarget?: ScrollTarget;
  currentHotel?: CurrentHotelStore;
  vipMessage?: string;
  propertyTypeBadge?: string; // Experiment: 32599 Property_Type_Badging
  bento?: BentoStore;
}

export type LocalizedPropertySummaryProps = LocalizedComponentProps & PropertySummaryProps;

@withRouter
@withLocalization
@inject('bento')
export class PropertySummary extends React.Component<LocalizedPropertySummaryProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const {
      backToHsrUrl,
      goBack,
      hotelName,
      englishHotelName,
      stars,
      starRatingIcon,
      stickyOffer,
      roomsAndRatesTarget,
      currentHotel,
      vipMessage,
      propertyTypeBadge,
      bento
    } = this.props;

    // When the expandedPropertySummary flag is set
    if (bento && bento.isFeatureActive(BentoFeature.EXPANDED_PROPERTY_SUMMARY)) {
      const navigateTabsCallback = () => {
        const tabGroup = NavigationRefs.PageTabs.current;
        if (tabGroup) {
          const accomTab = tabGroup.props.tabs.find(tab => tab.rfrr === 'Tab.Accommodation');
          const label = accomTab && accomTab.label;
          if (label) {
            const instance = tabGroup.wrappedInstance || tabGroup;
            instance.handleTabClick(label);
          }
        }
      };

      return (
        <ExpandedPropertySummary
          backToHsrUrl={backToHsrUrl}
          goBack={goBack}
          vipMessage={vipMessage}
          propertyTypeBadge={propertyTypeBadge}
          hotelName={hotelName}
          englishHotelName={englishHotelName}
          stars={stars}
          starRatingIcon={starRatingIcon}
          stickyOffer={stickyOffer}
          roomsAndRatesTarget={roomsAndRatesTarget}
          currentHotel={currentHotel}
          navigateTabs={navigateTabsCallback}
        />
      );
    }

    return (
      <Viewport>
        <ViewSmall />
        <ViewLarge>
          <ExpandedPropertySummary
            backToHsrUrl={backToHsrUrl}
            goBack={goBack}
            vipMessage={vipMessage}
            propertyTypeBadge={propertyTypeBadge}
            hotelName={hotelName}
            englishHotelName={englishHotelName}
            stars={stars}
            starRatingIcon={starRatingIcon}
            stickyOffer={stickyOffer}
            roomsAndRatesTarget={roomsAndRatesTarget}
            currentHotel={currentHotel}
          />
        </ViewLarge>
      </Viewport>
    );
  }
}

interface ExpandedPropertySummaryProps {
  backToHsrUrl: string;
  goBack: () => void;
  vipMessage?: string;
  propertyTypeBadge?: string; // Experiment: 32599 Property_Type_Badging
  hotelName?: string;
  englishHotelName?: string;
  stars?: string;
  starRatingIcon?: string;
  stickyOffer?: StickyOfferModel;
  roomsAndRatesTarget?: ScrollTarget;
  currentHotel?: CurrentHotelStore;
  navigateTabs?: () => any;
}

const ExpandedPropertySummary: React.FC<ExpandedPropertySummaryProps> = props => {
  const {
    backToHsrUrl,
    goBack,
    vipMessage,
    propertyTypeBadge,
    hotelName,
    englishHotelName,
    stars,
    starRatingIcon,
    stickyOffer,
    roomsAndRatesTarget,
    currentHotel,
    navigateTabs
  } = props;

  return (
    <UitkCard className="uitk-flat-border-top uitk-flat-border-bottom all-l-padding-three all-r-padding-three">
      <UitkCardContent>
        <BackLink className="all-t-padding-three" backToHsrUrl={backToHsrUrl} goBack={goBack} />
        <PropertyBadges vipMessage={vipMessage} propertyTypeBadge={propertyTypeBadge} />
        <InformationLarge
          name={hotelName}
          englishName={englishHotelName}
          stars={stars}
          starRatingIcon={starRatingIcon}
          stickyOffer={stickyOffer}
          target={roomsAndRatesTarget}
          withPrice={false}
          currentHotel={currentHotel}
          navigateTabs={navigateTabs}
        />
      </UitkCardContent>
    </UitkCard>
  );
};
